import { Table, Spinner } from "react-bootstrap";
import { dateDiff } from "../../../../_helpers/dateFormatter";
import { tagStatusColors } from "../../../../_helpers/tagStatusColors";
export const ShortlistedCandidates = ({
  candidateListData,
  user,
  onViewCandidateResponseClick,
  isCandidateLoading,
}) => {
  return (
    <div>
      <Table responsive="lg" className="custom-table mentor-table">
        <thead>
          <tr>
            <th>Candidate Name</th>
            <th>Status</th>
            {/* <th>Skills</th> */}
            <th>Last Updated</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {isCandidateLoading ? (
            <tr>
              <td colSpan={4} className="text-center">
                <Spinner variant="primary" />
              </td>
            </tr>
          ) : (
            <>
              {Array.isArray(candidateListData) && candidateListData.length ? (
                <>
                  {Array.isArray(candidateListData) &&
                    candidateListData.map((item) => (
                      <>
                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              {/* <button className="border-0 bg-transparent">
                            <img
                              src="/assets/images/star-grey.svg"
                              alt="star"
                            />
                          </button> */}
                              <div className="d-flex candidate-info flex-wrap">
                                <div className="candiate-img">
                                  <img
                                    src="/assets/images/user.png"
                                    alt="candidate"
                                  />
                                </div>
                                <div className="candiate-content">
                                  <p className="font-weight-bold text-black mb-1">
                                    {item?.candidate_id?.full_name}
                                  </p>
                                  {item?.reviewed_by_id !== null ?
                                    <p className="mb-0">
                                      {" "}Reviewed By:{" "}
                                      {item?.assigned_by_id === item?.reviewed_by_id ?
                                        "You" : item?.reviewed_by_id && item.reviewed_by_id?.full_name
                                      }
                                    </p>: "Not review by anyone"
                                  }
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span
                              className={`${tagStatusColors(
                                item?.status
                              )} text-capitalize`}
                            >
                              
                              {item?.status}{" "}
                              {item?.status === "shortlisted" && (
                                <>
                                  {item?.reviewed_by_id?.id === user?.user.id
                                    ? "by You"
                                    : `by ${item?.reviewed_by_id?.full_name}`}
                                </>
                              )}
                            </span>
                          </td>
                          {/* <td>
                        <ul className="skill-list">
                          <li>Figma</li>
                          <li>Adobe</li>
                          <li>Html</li>
                          <li>Figma</li>
                          <li>Adobe</li>
                          <li>Html</li>
                        </ul>
                      </td> */}
                          <td>
                            {item?.created_at &&
                              dateDiff(item?.created_at, new Date())}{" "}
                            ago
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <button
                                className="bg-transparent border-0 font-weight-medium text-primary"
                                onClick={() =>
                                  onViewCandidateResponseClick(item?.id)
                                }
                              >
                                View
                              </button>
                            </div>
                          </td>
                        </tr>
                      </>
                    ))}
                </>
              ) : (
                <tr>
                  <td colSpan={4} className="font-bold text-center text-danger">
                    No candidate found!
                  </td>
                </tr>
              )}
            </>
          )}
        </tbody>
      </Table>
      {/* <div className="d-flex p-3 border-top">
        <span>Page 1 of 10</span>
        <div className="d-flex ml-auto">
          <button className="bg-transparent py-2 border rounded-lg shadow-sm px-3 font-weight-semi ">
            Previous
          </button>
          <button className="bg-transparent rounded-lg ml-2 py-2 border shadow-sm px-3 font-weight-semi ">
            Next
          </button>
        </div>
      </div> */}
    </div>
  );
};
